import React from 'react';
import StyledCard from './Styles';

const Card = (props) => {
  const { children, ...otherProps } = props;
  return <StyledCard {...otherProps}>{children}</StyledCard>;
};

export default Card;
